/* Get Equity Percentage */
export const getEquityPercentage = (equity?: number, price?: number): number => {
    if (equity && price && typeof equity === 'number' && typeof price === 'number') return (equity * 100) / price;
    return 0;
};

/* Get Nominal Interest */
export const getNominalInterest = (equity: number, price: number, product: any): number => {
    const hasProduct = Object.keys(product).length > 0;

    if (equity !== undefined && price !== undefined && hasProduct) {
        const equityPercentage = getEquityPercentage(equity, price);
        const {
            equityPercentThresholdMidInterest,
            equityPercentThresholdMaxInterest,
            nomInterestMinEquity,
            nomInterestMidEquity,
            nomInterestMaxEquity,
        } = product;

        if (equityPercentThresholdMidInterest && equityPercentThresholdMaxInterest) {
            if (equityPercentage < equityPercentThresholdMidInterest) return nomInterestMinEquity;
            if (
                equityPercentage >= equityPercentThresholdMidInterest &&
                equityPercentage < equityPercentThresholdMaxInterest
            ) {
                return nomInterestMidEquity;
            }
            if (equityPercentage >= equityPercentThresholdMaxInterest) return nomInterestMaxEquity;
            return nomInterestMinEquity;
        }
    }
    return 0;
};
